// extracted by mini-css-extract-plugin
module.exports = {"uvp-banner":"uvp_uvp-banner__5N8bC","uvp-main":"uvp_uvp-main__oxDa_","uvp-item":"uvp_uvp-item__ZUN7s","uvp-title":"uvp_uvp-title___q3vx"};